import { useCallback } from 'react';
import useHttp from './useHttp';
import { toast } from 'react-toastify';
import { useAuth } from '../context/authContext';

export default function useEmergencyTotp() {
  const { sendRequest } = useHttp();
  const auth = useAuth();

  const generate = useCallback(
    async ({ issuer = 'FunZone', accountName = 'Locationserver', passphrase = '' } = {}) => {
      try {
        const data = await sendRequest({
          url: '/api/v1/emergency-totp/generate',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + auth.token,
          },
          body: { issuer, account: accountName, accountName, passphrase: passphrase || undefined },
        });
        const payload = data?.data || data;
        if (!payload) return null;
        // normalize otpauth field naming
        if (payload.otpauthURL && !payload.otpauthUri) payload.otpauthUri = payload.otpauthURL;
        return payload;
      } catch (e) {
        toast.error('Fehler beim Erzeugen des TOTP-Secrets');
        throw e;
      }
    },
    [sendRequest, auth.token]
  );

  return { generate };
}
